module.exports = __webpack_public_path__ + "static/media/ProjectManagement.6c3912ff.jpg";